export class DhConfigInfo {
    customer = "";
    name = "";
    hasConfigError = false;
    hasRuntimeError = false;
    hasPlannedTask = false;
}
